import { defineMessages } from 'react-intl';

export default defineMessages({
    effectiveDate: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.effectiveDate',
        defaultMessage: 'EFFECTIVE DATE'
    },
    term: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.term',
        defaultMessage: 'TERM'
    },
    delivery: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.delivery',
        defaultMessage: 'DELIVERY'
    },
    paymentOption: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.paymentOption',
        defaultMessage: 'PAYMENT OPTION'
    },
    coveragePackageLevelLabel: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.coveragePackageLevel',
        defaultMessage: '<a>COVERAGE LEVEL</a>'
    },
    offeringDefinitionsLabel: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.offeringDefinitions',
        defaultMessage: 'Offering Definitions'
    },
    createProposal: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.createProposal',
        defaultMessage: 'CREATE PROPOSAL'
    },
    saveToAccount: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.saveToAccount',
        defaultMessage: 'SAVE TO ACCOUNT'
    },
    orderMvr: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.orderMvr',
        defaultMessage: 'ORDER MVR'
    },
    orderMvrLoading: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.orderMvrLoading',
        defaultMessage: 'Ordering MVR on driver(s)…'
    },
    mvrNotOrderedWarning: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrNotOrderedWarning',
        defaultMessage: 'MVR has not been ordered yet.'
    },
    mvrOrderedError: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrOrderedError',
        defaultMessage: 'An MVR cannot be ordered without a valid Driver\'s License and State. Please update the Driver\'s License and State for each driver before proceeding with the MVR order.'
    },
    mvrDuplicateLicenseError: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrDuplicateLicenseError',
        defaultMessage: 'More than one driver has the same license number; we are unable to order the MVRs until this has been corrected. Please, go to the Drivers page or the Additional Info to Purchase page to update the license numbers for applicable drivers.'
    },
    mvrNoResultsSuccess: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrNoResultsSuccess',
        defaultMessage: 'No activities were found.'
    },
    mvrResultsPendingOrDelayed: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrResultsPendingOrDelayed',
        defaultMessage: 'MVR results are pending or delayed.'
    },
    mvrDMVError: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrDMVError',
        defaultMessage: 'The Department of Motor Vehicles cannot process the Motor Vehicle report due to Invalid Name, Gender, DOB or License Number.  Please verify these fields.'
    },
    premium: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.premium',
        defaultMessage: 'PREMIUM'
    },
    boldValuePerTerm: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.boldValuePerTerm',
        defaultMessage: '{boldValue}/{term}'
    },
    month: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.month',
        defaultMessage: 'month'
    },
    sevenDays: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.sevenDays',
        defaultMessage: '7 days'
    },
    mailCommPref: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mailCommPref',
        defaultMessage: 'Mail'
    },
    payInFull: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.payInFull',
        defaultMessage: 'Pay in Full'
    },
    installments: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.installments',
        defaultMessage: 'Installments'
    },
    recurring: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.recurring',
        defaultMessage: 'Recurring'
    },
    mortgagee: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mortgagee',
        defaultMessage: 'Mortgagee'
    },
    payrollDeduction: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.payrollDeduction',
        defaultMessage: 'Payroll Deduction'
    },
    checkingSavingsAcc: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.checkingSavingsAcc',
        defaultMessage: 'Checking/Savings Account - '
    },
    creditDebitCard: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.creditDebitCard',
        defaultMessage: 'Credit/Debit Card - '
    },
    sendBill: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.sendBill',
        defaultMessage: 'Send a Bill - '
    },
    error: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.error',
        defaultMessage: 'Error'
    },
    proposalError: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.proposalError',
        defaultMessage: 'Quote proposal document is not available yet. Please try again later.'
    },
    emailQuoteDescription: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.emailQuoteDescription',
        defaultMessage: 'Thank you. An email with your quote has been sent to {emailAddress_ML}'
    },
    goToForemostStar: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.goToForemostStar',
        defaultMessage: 'GO TO ForemostSTAR'
    },
    somethingWentWrong: {
        id: 'ml.agent.quoteandbind.common.Something went wrong during this process.  Please try again.',
        defaultMessage: 'Something went wrong during this process.  Please try again.'
    },
    mvrTechnicalErrorMessage: {
        id: 'ml.gateway.quoteandbind.common.quoteproposal.mvrTechnicalErrorMessage',
        defaultMessage: 'Motor Vehicle Record not available at this time, please try again later.'
    }
});
